import React from "react";
import "./Footer.css";
import { Fade } from "react-reveal";
import emoji from "react-easy-emoji";

export default function Footer() {
  return (
    <Fade bottom duration={1000} distance="5px">
    <div className="footer-div">
      <p className="footer-text"> <a target="_blank" href="https://github.com/mehul-anshumali"> { emoji("Mehul Anshumali 💓")} </a> </p>
      <img className="footer-img" alt="footer" src={require("../../assets/images/footer.jpg")}></img>
        
    </div>
    </Fade>
  );
}
